<template>
  <nav class="navbar is-fixed-top is-primary" :class="{'navbar-staging': isStaging}" role="navigation" aria-label="main navigation" v-if="$store.state.user">
    <snow v-if="isFestivus"/>
    <falling v-if="isFestivus && specialFalling" @end="specialFalling = false" />

    <div class="navbar-brand">
      <div class="navbar-item" style="font-size: 20px; font-weight: 700;">
        {{title}}
      </div>

      <a class="navbar-item has-text-weight-semibold" @click.stop="openSearch()">
        <font-awesome-icon icon="magnifying-glass" />
        Ricerca
      </a>

      <div class="is-hidden-desktop is-flex ml-auto">
        <a class="navbar-item has-text-white" v-if="toClose">
          <font-awesome-icon icon="bell" class="bell" /> {{ toClose }}
        </a>
        <a
          role="button"
          class="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
          @click="toggleMenu()"
          @click.stop
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
    </div>

    <div
      id="navbarBasicExample"
      class="navbar-menu"
      :class="{ 'is-active': openMenu }"
    >
      <div class="navbar-start">
        <router-link to="/clienti" class="navbar-item" :class="{'is-active': currentRoute.includes('/clienti')}" @click="toggleMenu()" v-if="$store.getters.amAdmin">
          <font-awesome-icon icon="users" />
          Clienti
        </router-link>
        <router-link to="/luoghi" class="navbar-item" :class="{'is-active': currentRoute.includes('/luoghi')}" @click="toggleMenu()" v-if="$store.getters.amAdmin">
          <font-awesome-icon icon="building" />
          Luoghi
        </router-link>
        <router-link to="/impianti" class="navbar-item" :class="{'is-active': currentRoute.includes('/impianti')}" @click="toggleMenu()" v-if="$store.getters.amAdmin">
          <font-awesome-icon icon="temperature-arrow-up" />
          Impianti
        </router-link>
        <router-link to="/calendario" class="navbar-item" :class="{'is-active': currentRoute.includes('/calendario')}" @click="toggleMenu()">
          <font-awesome-icon icon="calendar-week" />
          Calendario
        </router-link>
        <router-link to="/appuntamenti" class="navbar-item" :class="{'is-active': currentRoute.includes('/appuntamenti')}" @click="toggleMenu()">
          <font-awesome-icon icon="file-lines" />
          Appuntamenti
        </router-link>
        <router-link to="/scadenze" class="navbar-item" :class="{'is-active': currentRoute.includes('/scadenze')}" @click="toggleMenu()" v-if="$store.getters.amAdmin">
          <font-awesome-icon icon="calendar-days" />
          Scadenze
        </router-link>
        <router-link to="/chiamate" class="navbar-item" :class="{'is-active': currentRoute.includes('/chiamate')}" @click="toggleMenu()">
          <font-awesome-icon icon="phone-volume" />
          Chiamate
        </router-link>
        <router-link to="/ordini" class="navbar-item" :class="{'is-active': currentRoute.includes('/ordini')}" @click="toggleMenu()">
          <font-awesome-icon icon="file-invoice" />
          Ordini
        </router-link>
        <router-link to="/magazzino" class="navbar-item" :class="{'is-active': currentRoute.includes('/magazzino')}" @click="toggleMenu()">
          <font-awesome-icon icon="boxes-stacked" />
          Magazzino
        </router-link>
        <router-link to="/mappa" class="navbar-item" :class="{'is-active': currentRoute.includes('/mappa')}" @click="toggleMenu()" v-if="$store.getters.amAdmin">
          <font-awesome-icon icon="map-location" />
          Mappa
        </router-link>
      </div>

      <div class="navbar-end">
        <santa v-if="isFestivus" @click="specialFalling = true" />
        <a class="navbar-item" v-if="toClose">
          <font-awesome-icon icon="bell" class="bell" /> {{ toClose }}
        </a>
        <router-link to="/bozze" class="navbar-item" :class="{'is-active': currentRoute.includes('/bozze')}" @click="toggleMenu()">
          <font-awesome-icon icon="pen-ruler" />
          Bozze
        </router-link>
        <router-link to="/import" class="navbar-item" :class="{'is-active': currentRoute.includes('/import')}" @click="toggleMenu()">
          <font-awesome-icon icon="file-import" />
          Import
        </router-link>
        <router-link class="navbar-item" to="/profile" @click="isOpen = false">
          <font-awesome-icon icon="user-gear" />Impostazioni
        </router-link>
        <a class="navbar-item" @click="logout()">
          <font-awesome-icon icon="sign-out-alt" />Logout
        </a>
      </div>
    </div>

    <GlobalSearchOverlay v-model="openSearchOverlay" />
  </nav>
</template>

<script>
import santa from './extra/santa.vue'
import snow from './extra/snow.vue'
import falling from './extra/falling.vue'
import GlobalSearchOverlay from './GlobalSearchOverlay.vue'

export default {
  props: ['toClose'],

  components: {
    santa,
    snow,
    falling,
    GlobalSearchOverlay
  },

  data() {
    return {
      openMenu: false,
      title: import.meta.env.VITE_TITLE,
      isStaging: false,

      specialFalling: false,
      openSearchOverlay: false
    }
  },

  computed: {
    currentRoute() {
      const route = this.$route
      return route.path
    },

    isFestivus() {
      const d = new Date()
      const month = d.getMonth()+1
      
      const isFestivus = month === 12 && this.$store.state.user?.festivus

      return isFestivus
    }
  },

  methods: {
    toggleMenu() {
      this.openMenu = !this.openMenu
    },

    closeMenu() {
      this.openMenu = false
    },

    openSearch() {
      this.openSearchOverlay = true
      this.openMenu = false
    },

    logout() {
      const self = this

      this.$http.get('/user/logout')
      .then(function (response) {
        self.openMenu = false
        self.$store.commit('setUser', false)
        self.$router.push('/login')
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  },

  created() {
    window.addEventListener('click', () => this.closeMenu())

    this.isStaging = import.meta.env.VITE_ENV === 'staging'
  },

  beforeUnmount() {
    window.removeEventListener('click', () => this.closeMenu())
  }
}
</script>